import { Await, useLoaderData, useOutlet } from "react-router-dom";
import { Suspense } from "react";
import { Alert, LinearProgress } from "@mui/material";

export const AuthLayer = () => {
  const outlet = useOutlet();
  const { userPromise } = useLoaderData();

  return (
    <Suspense fallback={<LinearProgress />}>
      <Await
        resolve={userPromise}
        errorElement={<Alert severity="error">Something went wrong</Alert>}
      >
        {() => outlet}
      </Await>
    </Suspense>
  );
};
